import { ReactNode, useState } from 'react'

import { Panel, PanelBody, PanelHeading } from './Panel'

export function Accordion({
  id,
  heading,
  headingStyle,
  className = '',
  style,
  children,
}: {
  id?: string
  heading: ReactNode
  headingStyle?: React.CSSProperties
  className?: string
  style?: React.CSSProperties
  children: ReactNode
}) {
  const [open, setOpen] = useState(false)

  return (
    <Panel variant="default" id={id} className={className} style={style}>
      <PanelHeading role="button" aria-expanded={open} onClick={() => setOpen(!open)} style={{ cursor: 'pointer', ...headingStyle }}>
        <h5 className="panel-title">
          <div className="row">{heading}</div>
        </h5>
      </PanelHeading>
      <div className={`panel-collapse collapse${open ? ' in' : ''}`} role="tabpanel">
        <PanelBody>{children}</PanelBody>
      </div>
    </Panel>
  )
}
